module.exports = __webpack_public_path__ + "static/media/cart.374810cf.svg";